/** Checks if a creditcard style expiration data is expired */
export const isCreditCardExpired = (month, year) => {
    const today = new Date();
    const expirationDate = new Date();
    expirationDate.setFullYear(year, month);
    return expirationDate < today;
};
